import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import arrowDown from 'static/arrow_green_down.svg';
import arrowUp from 'static/arrow_green_up.svg';
import classNames from 'classnames';

const SortButton = ({ classes, input: { onChange, value }, className, label, onClick, sortBy }) => {
  const handleOnClick = () => {
    onChange(!value);
    if (onClick) {
      onClick(sortBy, !value);
    }
  };

  return (
    <button
      type="button"
      onClick={handleOnClick}
      className={classNames(classes.sortButton, className)}>
      <span className={classes.buttonText}>{label}</span>
      {value !== -1 ? <img src={value ? arrowUp : arrowDown} alt="arrow" /> : null}
    </button>
  );
};

SortButton.propTypes = {
  classes: PropTypes.object.isRequired,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.any,
  }).isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  ascValue: PropTypes.string,
  sortBy: PropTypes.string,
};

export default withStyles(styles)(SortButton);
